<template>
    <v-card>
        <v-card-title>
        <span class="headline">Claim Reserve Category Detail</span>
      </v-card-title>
      <v-card-text>
        <message :messages="messages"></message>
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 v-if="newClmResCat">
                <v-text-field :label="labels.resCat" v-model="clmResCatForm.resCat" :error-messages="errors.collect('resCat')" data-vv-name="resCat" :data-vv-as="labels.resCat" v-validate="'required|param|max:3'"></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.resCat}}</v-subheader>
                <div class="title">{{clmResCatForm.resCat}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="clmResCatForm.resCatShortDesc" :label="labels.resCatShortDesc" :error-messages="errors.collect('resCatShortDesc')" v-validate="'required|entry|max:6'" data-vv-name="resCatShortDesc" :data-vv-as="labels.resCatShortDesc"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="clmResCatForm.resCatLongDesc" :label="labels.resCatLongDesc" :error-messages="errors.collect('resCatLongDesc')" v-validate="'required|entry|max:20'" data-vv-name="resCatLongDesc" :data-vv-as="labels.resCatLongDesc"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" flat @click.native="doCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
      </v-card-actions>
    </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'

export default {
  props: {
    'clmResCatForm': Object,
    'newClmResCat': Boolean
  },
  data() {
    return {
      labels: {
        resCat: 'Reserve Category*',
        resCatShortDesc: 'Short Description*',
        resCatLongDesc: 'Long Description*'
      },
      submitting: undefined
    }
  },
  methods: {
    doInit() {
      this.resetMessages()
      this.clmResCatForm.resCat = undefined
      this.clmResCatForm.resCatShortDesc = undefined
      this.clmResCatForm.resCatLongDesc = undefined
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newClmResCat) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.claimParam.menu.createClmResCat
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.clmResCatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async doUpdate() {
      const apiURI = this.$store.state.claimParam.menu.updateClmResCat
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.clmResCatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doInit()
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    doCancel() {
      this.doInit()
      this.$emit('close')
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style>

</style>
